import { WorkflowsRoutePath } from "#src/routes/workflows";
import { RoutePath } from "#src/utils/route";

export const WorkflowTemplatesRoutePath = WorkflowsRoutePath.concat(
  new RoutePath({
    path: "/templates",
    title: "Workflow Templates",
  })
);
